<template>
  <div class="etoro-progress-loader">
    <div class="content">
      <img
        src="../../../assets/etoro/etoro-logo.svg"
        class="etoro-logo"
        alt="Etoro Logo"
      >
      <progress-stage-loader
        :current-stage="props.progressState.currentStage"
        :completed-stages="props.progressState.completedStages"
        :error="props.progressState.error"
        :status-message="props.progressState.statusMessage"
        :flow-config="etoroFlowConfig"
        force-text-color="#202125"
        force-font-family="SalaryFinance"
      />
    </div>
  </div>
</template>

<script setup>
import Segment from '../../../Segment';
import ProgressStageLoader from '../../Common/ProgressStageLoader.vue';

const props = defineProps({
  jobId: {
    type: String,
    required: true,
  },
  progressState: {
    type: Object,
    required: true,
  },
});

const etoroFlowConfig = {
  title: 'Analysing your data',
  description: 'This might take up to a few minutes to complete.',
  subDescription: '',
  stageMessages: {
    scrape: 'Collecting your financial data...',
    versionUpdate: 'Validating and organizing your account information...',
    featurama: 'Analysing your spending patterns to identify opportunities...',
    otis: 'Generating personalised recommendations for your financial goals...',
  },
};

// Track when component is entered
Segment.trackUserGot('EtoroProgressLoaderEntered');
</script>

<style lang="scss" scoped>
.etoro-progress-loader {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #F6F8ED; // Etoro specific background
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.etoro-logo {
  width: 50%;
  margin-top: 25px;
  max-width: 200px;
}
</style>
